import { render, staticRenderFns } from "./tianjin.vue?vue&type=template&id=a923c9a2&scoped=true"
import script from "./tianjin.vue?vue&type=script&lang=js"
export * from "./tianjin.vue?vue&type=script&lang=js"
import style0 from "./tianjin.vue?vue&type=style&index=0&id=a923c9a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a923c9a2",
  null
  
)

export default component.exports